import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import './About.css';
import { getApiUrl } from '../utils/api';
  
const About = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    const url = getApiUrl('/api/about-us');
    fetch(url)
      .then(res => res.json())
      .then(data => {
        console.log("Fetched about data:", data);
        if (data && Array.isArray(data.data) && data.data.length > 0) {
          setAboutData(data.data[0]);
        }
      })
      .catch(err => console.error("Error fetching about data:", err));
  }, []);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6
      }
    }
  };

  const imageVariants = {
    hidden: { x: 50, opacity: 0 },
    visible: {
      x: 0,
      opacity: 1,
      transition: {
        duration: 0.8
      }
    }
  };


  return (
    <section 
      id="about" 
      className="about" 
      ref={ref}
    >
      <motion.div
        className="about-container"
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        {/* Title - Mobile: Outside and Centered, Desktop: Inside */}
        <motion.h1 
          className="about-main-title about-title-mobile" 
          variants={itemVariants}
        >
          {aboutData?.title || "About Us."}
        </motion.h1>
        
        <div className="about-content">
          {/* Left Column - Content */}
          <motion.div 
            className="about-left" 
            variants={itemVariants}
            style={{
              position: 'relative',
              backgroundImage: isMobile ? `url(${aboutData?.imageUrl || '/aboutUs4.jpg'})` : 'none',
              backgroundSize: isMobile ? 'cover' : 'initial',
              backgroundPosition: isMobile ? 'center' : 'initial',
              backgroundRepeat: isMobile ? 'no-repeat' : 'initial',
            }}
          >
            <div 
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: isMobile ? 'rgba(0, 0, 0, 0.6)' : 'rgba(0, 0, 0, 0.6)',
                borderRadius: isMobile ? '16px' : '0',
                zIndex: 0,
                pointerEvents: 'none'
              }}
            />
            <div style={{ position: 'relative', zIndex: 1 }}>
            {/* Company Badge */}
            <div className="company-badge">
              <div className="badge-line"></div>
              <span className="badge-text">GLOBESOFT COMPANY</span>
            </div>

            {/* Main Title - Desktop Only */}
            <h1 className="about-main-title about-title-desktop">{aboutData?.title || "About Us."}</h1>

            {/* Description */}
            <p className="about-description">
              {aboutData?.description || "GlobeSoft Solutions is a leading technology company specializing in cutting-edge digital solutions. We excel in AI-powered applications, Flutter mobile development, Golang backend services, and AWS cloud infrastructure."}
            </p>
            
            {/* Key Points */}
            <div className="key-points">
              {aboutData?.bulletPoints ? (
                aboutData.bulletPoints.map((point, index) => (
                  <div key={index} className="key-point-item">
                    <div className="key-point-icon">•</div>
                    <span className="key-point-text">{point}</span>
                  </div>
                ))
              ) : (
                <>
                  <div className="key-point-item">
                    <div className="key-point-icon">•</div>
                    <span className="key-point-text">Comprehensive IT Services with Scalable Results</span>
                  </div>
                  <div className="key-point-item">
                    <div className="key-point-icon">•</div>
                    <span className="key-point-text">Around-the-Clock Support for Global Clients</span>
                  </div>
                </>
              )}
            </div>

            {/* CTA Button */}
            {/* <button className="about-cta-button">EXPLORE MORE</button> */}

            {/* Stats Box */}
           
            </div>
          </motion.div>

          {/* Right Column - Images */}
          <motion.div className="about-right" variants={imageVariants}>
            <div className="images-container">
              {/* Top Image with Video Button */}
              <div className="top-image-container">
                <img 
                  src={aboutData?.imageUrl || "/aboutUs4.jpg"} 
                  alt={aboutData?.title || "About Us"} 
                  className="top-image"
                />
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>
  );
};

export default About;


